/* FILM 01 · THE BOX OFFICE — quantity, add to cart, and the phone buy bar. */
/* THE REST OF THE LINEUP — the posters' ADD TO CART (their handlers live in the homepage/shop scripts,
   which this page does not load) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.nhp-fp-lineup [data-nhp-add]');
  if (!btn || !window.NNCart) return;
  var label = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'ADDING…';
  window.NNCart.addAndOpen(btn.getAttribute('data-nhp-add'), 1)
    .then(function () { btn.textContent = label; })
    .catch(function () { btn.textContent = 'TRY AGAIN'; })
    .then(function () { btn.disabled = false; });
});

(function () {
  var root = document.querySelector('[data-nhp-fp]');
  if (!root) return;

  var out = root.querySelector('[data-nhp-qty-n]');
  var max = out ? parseInt(out.getAttribute('data-max'), 10) || 10 : 1;
  var qty = 1;

  function syncQty() {
    if (!out) return;
    out.textContent = qty;
    root.querySelector('[data-nhp-qty="-1"]').disabled = qty <= 1;
    root.querySelector('[data-nhp-qty="1"]').disabled = qty >= max;
  }

  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-nhp-qty]');
    if (step) {
      qty = Math.min(max, Math.max(1, qty + parseInt(step.getAttribute('data-nhp-qty'), 10)));
      syncQty();
      return;
    }
    var btn = e.target.closest('[data-nhp-fp-add]');
    if (!btn || !window.NNCart) return;
    // a click never looks like nothing happened (same as homepage 07)
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    window.NNCart.addAndOpen(btn.getAttribute('data-nhp-fp-add'), qty)
      .then(function () { btn.textContent = label; })
      .catch(function () { btn.textContent = 'TRY AGAIN'; })
      .then(function () { btn.disabled = false; });
  });
  syncQty();

  // THE GALLERY — thumbnails jump to a slide; swiping moves the lit thumbnail. The jar video plays
  // only while its slide is showing AND on screen, never under reduced motion, and stays paused once
  // someone pauses it.
  var slides = root.querySelector('[data-nhp-slides]');
  var items = slides ? [].slice.call(slides.querySelectorAll('[data-nhp-slide]')) : [];
  var thumbs = [].slice.call(root.querySelectorAll('[data-nhp-go]'));
  var video = slides && slides.querySelector('video');
  var pp = root.querySelector('[data-nhp-playpause]');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var userPaused = reduce;
  var onVideo = false;
  var inView = false;

  function syncVideo() {
    if (!video) return;
    var go = onVideo && inView && !userPaused && !document.hidden;
    if (go) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } else { video.pause(); }
    if (pp) {
      pp.setAttribute('aria-pressed', String(userPaused));
      pp.setAttribute('aria-label', userPaused ? 'Play video' : 'Pause video');
    }
  }

  function setActive(i) {
    thumbs.forEach(function (b, n) {
      b.classList.toggle('is-on', n === i);
      b.setAttribute('aria-selected', String(n === i));
    });
    onVideo = !!(video && items[i] && items[i].contains(video));
    syncVideo();
  }

  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      var i = parseInt(b.getAttribute('data-nhp-go'), 10) || 0;
      slides.scrollTo({ left: i * slides.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
    });
  });

  if (pp) pp.addEventListener('click', function () { userPaused = !userPaused; syncVideo(); });
  if (video) video.addEventListener('click', function () { userPaused = !userPaused; syncVideo(); });
  document.addEventListener('visibilitychange', syncVideo);

  if (slides && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) setActive(items.indexOf(e.target)); });
    }, { root: slides, threshold: 0.6 });
    items.forEach(function (el) { io.observe(el); });
    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      syncVideo();
    }, { threshold: 0.3 }).observe(slides);
  }

  // phone buy bar: shown once the main button has scrolled up out of view, hidden when it's back
  var bar = root.querySelector('[data-nhp-fp-bar]');
  var buy = root.querySelector('[data-nhp-fp-buy]');
  if (!bar || !buy || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    var past = !e.isIntersecting && e.boundingClientRect.top < 0;
    bar.classList.toggle('is-shown', past);
    bar.inert = !past;
  }).observe(buy);
})();

/* SCREENS 2–5 — each [data-nhp-reveal] section gets .is-in once, the first time it is well in view
   (the jar opens, the meters light, the marquee bulbs flicker on). No observer = shown at once. */
(function () {
  var els = [].slice.call(document.querySelectorAll('[data-nhp-reveal]'));
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.35 });
  els.forEach(function (el) { io.observe(el); });
})();

/* THE VICTIMS (2026-09-24): the flavor's clip plays only while on screen, pauses off it, tap to pause.
   Never autoplays under reduced motion. */
(function () {
  var v = document.querySelector('[data-nhp-victims-clip]');
  if (!v) return;
  var btn = document.querySelector('[data-nhp-victims-pause]');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wanted = !reduce, onScreen = false;
  function apply() {
    if (wanted && onScreen && !document.hidden) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    else v.pause();
    if (btn) {
      btn.setAttribute('aria-pressed', wanted ? 'false' : 'true');
      btn.querySelector('.nhp-sr').textContent = wanted ? 'Pause the video' : 'Play the video';
    }
  }
  if (btn) btn.addEventListener('click', function () { wanted = !wanted; apply(); });
  document.addEventListener('visibilitychange', apply);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { onScreen = e[0].isIntersecting; apply(); }, { threshold: 0.3 }).observe(v);
  } else { onScreen = true; apply(); }
})();
